<template>
  <i :class="'iconfont ' + name" :style="styles" @click="iconClick"></i>
</template>

<script>
export default {
  name: 'iconfont',
  props: {
    name: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    color: {
      type: [String, Array],
      default: '',
    },
  },
  methods: {
    isEmpty(val) {
      if (val === undefined || val === null || val === '') {
        return true
      } else {
        return false
      }
    },
    iconClick() {
      this.$emit('click')
    },
  },
  computed: {
    styles() {
      let style = ''
      if (!this.isEmpty(this.size)) {
        style += `font-size: ${this.size};`
      }
      if (!this.isEmpty(this.color)) {
        style += `color: ${this.color};`
      }
      return style
    },
  },
}
</script>

<style>
@import url('./icon.css');
</style>